import { LEAVE_STATUSES } from './timeData'

/** "Still needs a decision": a filter sentinel, not a member of LEAVE_STATUSES. */
export const AWAITING = 'awaiting'

export const LEAVE_STATUS_KEY = 'status'

export type LeaveLinkScope = 'own' | 'awaiting' | 'team' | 'all' | 'admin'

/** `?status=` as the page's own filter value: `awaiting`, `all` (''), or one leave status; anything else is `null`. */
export function leaveStatusFromSearch(params: URLSearchParams): string | null {
  const raw = params.get(LEAVE_STATUS_KEY)
  if (raw === AWAITING) return AWAITING
  if (raw === 'all') return ''
  return LEAVE_STATUSES.find((s) => s === raw) ?? null
}

export function leaveHref(scope: LeaveLinkScope, status: string = AWAITING, opts: { open?: string } = {}): string {
  const params = new URLSearchParams({ scope, [LEAVE_STATUS_KEY]: status === '' ? 'all' : status })
  if (opts.open) params.set('open', opts.open)
  return `/leave?${params.toString()}`
}

/** One application opened over the widest list the reader may see: `all` needs the leave-admin ability. */
export function leaveRecordHref(id: string, isLeaveAdmin: boolean): string {
  return leaveHref(isLeaveAdmin ? 'all' : 'own', '', { open: id })
}
